"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFreshToken = void 0;
const exceptions_1 = require("./exceptions");
const getFreshToken = (okta, refreshToken) => __awaiter(void 0, void 0, void 0, function* () {
    const { clientId, clientSecret, orgDomain } = okta;
    let response;
    try {
        response = yield fetch(`https://${orgDomain}/oauth2/default/v1/token`, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': 'application/json',
            },
            body: new URLSearchParams({
                grant_type: 'refresh_token',
                refresh_token: refreshToken,
                client_id: clientId,
                client_secret: clientSecret,
            }),
            method: 'POST',
        });
    }
    catch (e) {
        console.error(`Failed to refresh access token: ${e.message}`);
        throw new exceptions_1.RefreshTokenFailedException();
    }
    if (!response.ok) {
        throw new exceptions_1.RefreshAccessTokenException();
    }
    return response.json();
});
exports.getFreshToken = getFreshToken;
//# sourceMappingURL=okta.js.map